import { Area } from "../models";
import { DateTime_fromTransferable, DateTime_toTransferable } from "../models/DateTime";
/**
 * Encode api error into a format that can be passed between threads
 */
export function MeteomaticsApiError_toTransferable(e) {
    switch (e.kind) {
        case "BoundsError":
            return {
                ...e,
                isEncodedApiError: true,
                kind: "BoundsError_Transferable",
                queried: e.queried.toTransferable(),
                available: e.available.toTransferable(),
            };
        case "TimeError":
            return {
                ...e,
                isEncodedApiError: true,
                kind: "TimeError_Transferable",
                given: DateTime_toTransferable(e.given),
                availableStart: DateTime_toTransferable(e.availableStart),
                availableEnd: DateTime_toTransferable(e.availableEnd),
            };
        case "ComputationTimeoutError":
            return {
                ...e,
                isEncodedApiError: true,
                kind: "ComputationTimeoutError_Transferable",
                processingTime: e.processingTime.toString(),
            };
        case "AuthError":
        case "UnknownError":
        case "UnknownParameterError":
        case "MissingDataError":
            return { ...e, isEncodedApiError: true };
        default: {
            const _exhaustive = e;
            return _exhaustive;
        }
    }
}
/**
 * Decode api error into a format that can be passed between threads
 */
export function MeteomaticsApiError_fromTransferable(e) {
    switch (e.kind) {
        case "BoundsError_Transferable":
            return {
                ...e,
                isEncodedApiError: false,
                kind: "BoundsError",
                queried: Area.fromTransferable(e.queried),
                available: Area.fromTransferable(e.available),
            };
        case "TimeError_Transferable":
            return {
                ...e,
                isEncodedApiError: false,
                kind: "TimeError",
                given: DateTime_fromTransferable(e.given),
                availableStart: DateTime_fromTransferable(e.availableStart),
                availableEnd: DateTime_fromTransferable(e.availableEnd),
            };
        case "ComputationTimeoutError_Transferable":
            return {
                ...e,
                isEncodedApiError: false,
                kind: "ComputationTimeoutError",
                processingTime: Number(e.processingTime),
            };
        case "AuthError":
        case "UnknownError":
        case "UnknownParameterError":
        case "MissingDataError":
            return { ...e, isEncodedApiError: false };
        default: {
            const _exhaustive = e;
            return _exhaustive;
        }
    }
}
export function isTransferableApiError(v) {
    return v && v.isEncodedApiError === true;
}
export function isNonTransferableApiError(v) {
    return v && v.isEncodedApiError === false;
}
export function isApiError(v) {
    return v && typeof v.isEncodedApiError === "boolean";
}
//# sourceMappingURL=transfer.js.map